/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseEffectiveResourceAccess } from '../../models/api-response-effective-resource-access';

export interface GetEffectiveAccess$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  resourceType: 'CONTACT' | 'PRODUCT';
}

export function getEffectiveAccess(http: HttpClient, rootUrl: string, params: GetEffectiveAccess$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseEffectiveResourceAccess>> {
  const rb = new RequestBuilder(rootUrl, getEffectiveAccess.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('resourceType', params.resourceType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseEffectiveResourceAccess>;
    })
  );
}

getEffectiveAccess.PATH = '/v1/api/ui/access/effective/{resourceType}';
